import {
  LIVE_CLASS_LIST_FAILED,
  LIVE_CLASS_LIST_REQ,
  LIVE_CLASS_LIST_SUCCESS,
} from "../Constant/LiveClassConstant";

export const list_LiveClassReducer = (
  state = {},
  { type, payload, MeetingData, DemoClasses }
) => {
  switch (type) {
    case LIVE_CLASS_LIST_REQ: {
      return { loading: true };
    }

    case LIVE_CLASS_LIST_SUCCESS: {
      return { loading: false, classRecs: payload, MeetingData, DemoClasses };
    }

    case LIVE_CLASS_LIST_FAILED: {
      return { loading: false, error: payload };
    }
    default:
      return state;
  }
};
